export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS'
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION'
